import '../index.css';
import IntroVideo from './IntroVideo';
import Navbar from './Navbar';

function MainContent() {
  return (
    <div className='main'>
      <h1>Brühm League Merchandise - Brühm League Trunks, T-Shirts und Bitcoins</h1>
      <IntroVideo embedId='Irhw-ju-bew' />
    </div>
  )
}

function Footer() {
  return (
    <footer className='footer'>
      © 2044 Femboy Factories. All rights reserved.
    </footer>
  )
}

export default function Page () {
  return (
    <div className='mainPage'>
      <div className='headerContent'>
        <Navbar />
        <MainContent />
      </div>
      <Footer />
    </div>
  )
}
